import React from 'react';
import PropTypes from 'prop-types';
import {DragSource, DropTarget} from 'react-dnd';

import Icon       from 'app/components/common/icon';
import {
  DndTypes,
}                 from 'app/constants';
import DragHandle from 'app/components/common/drag-handle';



class ListSlotBare extends React.PureComponent {

  onDrop({index: cardIndex}) {
    this.props.onDrop(cardIndex, this.props.index);
  }

  render() {
    const {connectDnd, dndIsOver, dndIsDragging, children, isActive, isExpanded} = this.props;
    const activeClass = isActive ? 'active' : '';
    const expandedClass = isExpanded ? 'expanded' : '';
    const dragClass = dndIsDragging ? 'dnd-is-dragging' : 'dnd-not-dragging';
    const overClass = dndIsOver ? 'dnd-is-over' : 'dnd-not-over';
    const showChildren = !dndIsOver;

    return connectDnd(
      <div className={`ca-bldr-sortable-slot ${dragClass} ${overClass} ${activeClass} ${expandedClass}`}>
        {showChildren && children}
      </div>
    );
  }

}

ListSlotBare.propTypes = {
  onDrop: PropTypes.func,
  onChangeDroppable: PropTypes.func,
  isActive: PropTypes.bool,
  isExpanded: PropTypes.bool,
};
ListSlotBare.defaultProps = {
  onDrop: () => {},
  onChangeDroppable: () => {},
  dndIsOver: false,
  dndIsDragging: false,
  isActive: false,
  isExpanded: false,
};

const dndDropSpec = {
  drop: (props, monitor, component) => {
    component.onDrop(monitor.getItem());
  },
  // hover: (props, monitor, component) => {},
  // canDrop: (props, monitor) => {},
};

const dndDropToProps = (connect, monitor, props) => ({
  connectDnd: connect.dropTarget(),
  dndIsOver: monitor.isOver(),
  dndIsDragging: monitor.canDrop(),
});

const ListSlot = DropTarget(DndTypes.BUILDER_LIST_ITEM, dndDropSpec, dndDropToProps)(ListSlotBare);








class ListCardBare extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {onToggleExpand, onClickItem} = this.props;
    onClickItem && onClickItem(this.props.index);
    onToggleExpand && onToggleExpand(this.props.index);
  }

  render() {
    const {label, icon: IconComp, isDeleted, isActive, connectDragSource, isExpanded, children, onToggleExpand} = this.props;
    const deletedClass = isDeleted ? 'deleted' : '';
    const activeClass = isActive ? 'active' : '';
    const expandedClass = isExpanded ? 'expanded' : '';
    const expandable = !!onToggleExpand;

    return connectDragSource(
      <div className={`ca-bldr-sortable-card ${deletedClass} ${activeClass} ${expandedClass}`}>
        <div className="ca-bldr-sortable-card-row" onClick={this.onClick}>
          <div className="ca-bldr-sortable-card-row-handle-con">
            <DragHandle className="ca-bldr-sortable-card-row-handle" />
          </div>
          {!!IconComp && <IconComp className="ca-bldr-sortable-card-row-icon" />}
          <div className="ca-bldr-sortable-card-row-label">{label}</div>
          {expandable && (
            <Icon.Caret direction={isExpanded ? 'up' : 'down'} className="ca-bldr-sortable-card-row-caret" />
          )}
        </div>
        {isExpanded && children}
      </div>
    );
  }
};

ListCardBare.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.object,
  index: PropTypes.number.isRequired,
  isExpanded: PropTypes.bool,
  onToggleExpand: PropTypes.func,
  onDragStart: PropTypes.func,
  children: PropTypes.node,
  isDeleted: PropTypes.bool.isRequired,
};
ListCardBare.defaultProps = {
  isExpanded: false,
  children: null,
};

const dndDragSpec = {
  beginDrag: (props, monitor, component) => {
    props.onDragStart();
    return {index: props.index};
  },
  // endDrag: (props, monitor, component) => {},
  // canDrag: (props, monitor) => {},
};

const dndDragToProps = (connect, monitor, props) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
});

const ListCard = DragSource(DndTypes.BUILDER_LIST_ITEM, dndDragSpec, dndDragToProps)(ListCardBare);











class CadminBuilderSortableList extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      expandedIndex: null,
    };

    this.onDrop = this.onDrop.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onToggleExpand = this.onToggleExpand.bind(this);
    this.onClickNew = this.onClickNew.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
  }

  onDrop(cardIndex, slotIndex) {
    const items = [...this.props.items];
    // sanity check
    if (cardIndex > (items.length - 1)) return;
    if (slotIndex > (items.length - 1)) return;
    // don't do a swap; do a shift
    const cardItem = items[cardIndex];
    items.splice(cardIndex, 1);
    items.splice(slotIndex, 0, cardItem);
    this.props.onChange(items);
  }

  onDragStart() {
    this.setState({expandedIndex: null});
  }

  onToggleExpand(index) {
    this.setState((prevState) => {
      const isExpanded = prevState.expandedIndex === index;
      return isExpanded
        ? {expandedIndex: null}
        : {expandedIndex: index};
    });
  }
  onClickItem(index) {
    const {items, onClickItem} = this.props;
    const item = items[index];
    onClickItem && onClickItem(item);
  }

  onClickNew() {
    this.props.onClickNew();
  }

  expandLast(delayMs=100) {
    setTimeout(() => {
      const lastIndex = this.props.items.length - 1;
      this.setState({expandedIndex: lastIndex});
    }, delayMs);
  }

  render() {
    const {items, getDetails, renderExpanded, onClickNew, className} = this.props;
    const {expandedIndex} = this.state;
    return (
      <div className={`ca-bldr-sortable ${className}`}>
        <div className="ca-bldr-sortable-list">
          {items.map((item, i) => {
            const {label, icon, isDeleted=false, isActive=false} = getDetails(item, i);
            const isExpanded = !!(renderExpanded && (expandedIndex === i));
            return (
              <ListSlot key={i} onDrop={this.onDrop} index={i} isActive={isActive} isExpanded={isExpanded}>
                <ListCard
                  item={item}
                  index={i}
                  label={label}
                  icon={icon}
                  onToggleExpand={renderExpanded ? this.onToggleExpand : null}
                  onClickItem={this.onClickItem}
                  onDragStart={this.onDragStart}
                  isExpanded={isExpanded}
                  isDeleted={isDeleted}
                  isActive={isActive}
                >
                  {isExpanded && renderExpanded(item, i)}
                </ListCard>
              </ListSlot>
            );
          })}
          {!!onClickNew && (
            <button className="btn small blue" onClick={this.onClickNew}>+ Add Another</button>
          )}
        </div>
      </div>
    );
  }

}

CadminBuilderSortableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  getDetails: PropTypes.func, // (item, index) => {label, icon, isDeleted}
  onChange: PropTypes.func.isRequired, // (items) => {}
  renderExpanded: PropTypes.func, // (item, index) => </>
  onClickNew: PropTypes.func,
  onClickItem: PropTypes.func,
  className: PropTypes.string,
};
CadminBuilderSortableList.defaultProps = {
  getLabel: item => item?.title || item?.name || item?.label || '',
  getIcon: () => null,
  className: '',
};


export default CadminBuilderSortableList;
